var countries = require('json!../../../../../config/countries.json');
angular
  .module('account.add-video', [
    'common.header',
    'common.footer',
    'config',
    'directives.contenteditable',
    'account.settings.social',
    'security.service',
    'security.authorization',
    'services.accountResource',
    'services.utility',
    'services.formErrors',
    'ui.bootstrap',
    'directives.serverError',
    'ngTagsInput',
    'ngFileUpload',
    'toggle-switch',
    'angular-growl',
    'ckeditor',
    'resources.User',
    'resources.Category',
    'resources.Article',
    'resources.Tag',
    'filters.rawHtml',
		'ckeditorPlaceholder',
		'services.localizedMessages',
  ])

  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('account.add-video', {
      url: '/add-video',
      title: 'Add Video',
      views: {
        'main@': {
          template: require('./add-video.tpl.html'),
          controller: 'AddVideoCtrl',
          resolve: {
            categories: ["Category", function (Category) {
              var options = [];
              var generateCategoryOptions = function (items, container) {
                items.forEach(function (item) {
                  if (!item.path) {
                    return;
                  }
                  var depth = item.path.split('/').filter(Boolean).length;
                  var indent = new Array(5).join(String.fromCharCode(160));
                  container.push({
                    _id: item._id,
                    id: item.id,
                    path: item.path,
                    sefriendly: item.sefriendly,
                    parent: item.parent,
                    parent_id: item.parent_id,
                    name: item.name,
                    _name: new Array(depth).join(indent) + item.name
                  });
                  if (item.children) {
                    generateCategoryOptions(item.children, container);
                  }
                });
                return container;
              };

              return Category.getPermittedTree({ type: 'video' }).$promise.then(function (data) {
                generateCategoryOptions(data, options);
                return options;
              });
            }],
            locations: ["adminResource", function (adminResource) {
              return adminResource.searchTags({ type: 'location' });
            }],
            playersAndTeams: ["adminResource", function (adminResource) {
              return adminResource.searchTags({ type1: 'profile', type2: 'organization' });
            }]
          }
        }
      }
    });
  }])

  .controller('AddVideoCtrl', ["$scope", "$location", "$log", "$interval", "$sce", "security", "utility", "growl", "user", "categories", "locations", "playersAndTeams", "adminResource", "SOCIAL", "STATUSES", "ARTICLE_STYLES", "APP_IMG_URLS", "Upload", "formErrors", "dateFilter", "Article", "Tag", "localizedMessages", function (
    $scope,
    $location,
    $log,
    $interval,
    $sce,
    security,
    utility,
    growl,
    user,
    categories,
    locations,
    playersAndTeams,
    adminResource,
    SOCIAL,
    STATUSES,
    ARTICLE_STYLES,
    APP_IMG_URLS,
    Upload,
    formErrors,
    dateFilter,
    Article,
		Tag,
		localizedMessages
  ) {
    var urlGenerated = false;
    var now = new Date();
    var timer = null;
    var currentDateTime = moment();
    var slugify = require('../../utils/slugify');
    $scope.countries = [];
    _.forIn(countries, function (value, key) {
      $scope.countries.push({
        _id: key,
        name: value
      });
		});
		
		$scope.localizedMessages = localizedMessages;
		STATUSES = STATUSES.map( (status) => Object.assign(status, { value: localizedMessages.get(status.value) }) );

		$scope.statuses = _.filter(STATUSES, function (status) {
			return ~user.permissions.statuses.indexOf(status.id);
		});


    var isProgram = user && user.account && user.account.is_program ? true : false;

    $scope.statuses = _.filter(STATUSES, function (status) {
      return ~user.permissions.statuses.indexOf(status.id);
    });
    if (user.permissions.statuses[0] === '*') {
      $scope.statuses = STATUSES;
    }
    $scope.categories = categories;
    $scope.stadiumsList = !!locations
      ? locations.data.map(function (p) {
          return { _id: p._id, name: p.name };
        })
      : [];
    $scope.playersAndTeamsList = !!playersAndTeams
      ? playersAndTeams.data.map(function (p) {
          return {
            _id: p._id,
            name: p.name,
            type: p.role.role_type
          };
        })
      : [];
    $scope.profilesList = $scope.playersAndTeamsList.length
      ? $scope.playersAndTeamsList.filter(function (e) {
          return e.type === 'profile';
        })
      : [];
    $scope.article_styles = ARTICLE_STYLES;
    // $scope.video_types = VIDEO_TYPES;
    $scope.alerts = [];
    $scope.uploading = false;
    $scope.completed = false;
    $scope.durations = [];
    $scope.isSaving = false;
    $scope.autosaveTimer = 180;
    $scope.imgUrl = APP_IMG_URLS['base'];
    $scope.accordion = {
      score: true,
      publishing_date: true,
      url: true,
      image: true,
      published_by: false
    };

    $scope.isAdmin = false;
    if (user.permissions.is_admin) {
      $scope.isAdmin = true;
    }
    $scope.data = {
      title: '',
      sefriendly: '',
      status: {
        id: '0',
        value: localizedMessages.get('pending')
      },
      type: 'video',
      image: '',
      video: '',
      duration: 0,
      video_type: isProgram ? 'program' : 'video',
      media_id: '',
      mediaCloud_id: '',
      arrThumbs: [],
      location: {
        lat: 0,
        lon: 0
      },
      locationInfo: {},
      image_caption: '',
      readyToStream: false,
      body: '',
      abstract: '',
      equipo_local: '',
      equipo_visitante: '',
      goals: '',
      goles_local: '',
      goles_visitante: '',
      referee: '',
      incidents: '',
      show_inarticle: ARTICLE_STYLES[2],
      category: '',
      tags: '',
      author: {
        picture: user.account.avatar || user.account.picture,
        avatar: user.account.avatar,
        twitter: user.account.twitter,
        plus: user.account.plus,
        name: user.account.name.full,
        username: user.username
      },
      orderNumber: 0,
      last_edited_by: {
        name: user.account.name.full,
        username: user.username
      },
      published_by: {
        name: '',
        username: ''
      },
      publish_date: currentDateTime.local().format('YYYY-MM-DD HH:mm')
    };

    // ==search place google==
    var input = document.getElementById('pac-input');
    // var searchBox = new window.google.maps.places.Autocomplete(input);
    // searchBox.addListener('place_changed', function () {
    //   var place = searchBox.getPlace();
    //   if (!place.geometry) {
    //     growl.error('Can not get location');
    //     return;
    //   }
    //   var lat = place.geometry.location.lat();
    //   var lon = place.geometry.location.lng();
    //   $scope.data.location = { lat: lat, lon: lon };
    //   $scope.data.locationInfo = {
    //     lat: lat,
    //     lon: lon,
    //     geometry: place.geometry,
    //     name: place.name,
    //     id: place.id,
    //     icon: place.icon,
    //     formatted_address: place.formatted_address,
    //     place_id: place.place_id,
    //     types: place.types,
    //     url: place.url,
    //     vicinity: place.vicinity
    //   };
    // });
    // ==search place google==

    $scope.progressPercentage = 0;
    $scope.videoUrl = '';
    $scope.onChangeVideoUrl = function () {
      $scope.videoUrl = $scope.data.video;
    };

    var startTimer = function () {
      return $interval(function () {
        if ($scope.autosaveTimer <= 0) {
          $scope.save();
        }
        $scope.autosaveTimer -= 1;
      }, 1000);
    };

    var resetTimer = function () {
      $scope.autosaveTimer = 180;
      $interval.cancel(timer);
    };

    $scope.autosaveChanged = function () {
      if ($scope.autosave) {
        timer = startTimer();
      } else {
        resetTimer();
      }
    };

    $scope.titleChanged = function () {
      $scope.data.title = $scope.data.title.replace(/<.+?>/g, '').replace(/  /g, ' ');
      if ($scope.data.sefriendly) {
        return;
      }
      $scope.data.sefriendly = slugify($scope.data.title.replace(/<.+?>/g, '').replace(/  /g, ' '));
      // console.log('>>>', $scope.data.sefriendly);
    };

    $scope.canChangeAuthor = function () {
      return user.permissions.is_editor && $scope.canChangeCategory();
    };

    $scope.canChangeCategory = function () {
      if (user.permissions.is_admin) return true;
      return true;

      // return ~user.permissions.categories.indexOf(article.category.id);
    };

    $scope.onReady = function () {
      CKEDITOR.on('dialogDefinition', function (ev) {
        // Take the dialog name and its definition from the event data

        var dialogName = ev.data.name;
        var dialogDefinition = ev.data.definition;
        if (dialogName == 'image2' || dialogName == 'link') {
          // Remove upload tab
          dialogDefinition.removeContents('Upload');
          dialogDefinition.removeContents('upload');
        }
      });
    };

    $scope.save = function () {
      if ($scope.uploading) {
        growl.error('Please wait for the upload process to complete');
        return;
      }
      resetTimer();
      $scope.autosaveChanged();
      $scope.data.sefriendly = slugify($scope.data.sefriendly);

      if (!$scope.data.video) {
        growl.error('Video is required');
        return;
      }
      //validate
      if (!$scope.data.title) {
        growl.error('Title is required');
        return;
      }

      if (!$scope.data.category) {
        growl.error('Category is required');
        return;
      }

      // if (!$scope.data.body) {
      //   growl.error('Body is required');
      //   return;
      // }

      $scope.isSaving = true;

      var data = angular.copy($scope.data);

      data.edition = data.category.path.split('/')[1];
      data.type = {
				id: '1',
				value: 'Wideo'
			};
      data.show_inarticle = 1;
      data.status = parseInt(data.status.id, null);
      data.category = {
        id: data.category.id,
        name: data.category.name,
        sefriendly: data.category.sefriendly,
        parent: data.category.parent,
        parent_id: data.category.parent_id
      };

      data.tags = data.tags || [];
      data.tags = data.tags.map(function (tag) {
        return {
          name: tag.text,
          sefriendly: slugify(tag.text),
          avatar: tag.avatar || ''
        };
      });

      data.publish_date = (data.publish_date ? moment(data.publish_date) : currentDateTime).toISOString();

      if (!$scope.canChangeAuthor()) {
        data.last_edited_by = {
          name: user.account.name.full,
          username: user.username
        };
      }

      if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
        data.published_by = {
          name: user.account.name.full,
          username: user.username
        };
      }

      var catArray = data.category.parent == '/' ? [] : data.category.parent.substring(1).split('/');
      var pDate = new Date(data.publish_date);
      var pMonth = pDate.getUTCMonth() + 1;
      var dateSeg =
        '/' +
        pDate.getUTCFullYear() +
        '/' +
        ('0' + pMonth).slice(-2) +
        '/' +
        ('0' + pDate.getUTCDate()).slice(-2) +
        '/';
      data.url_segment = dateSeg;
      if (catArray.length == 0) {
        data.url_segment = '/' + data.category.sefriendly + dateSeg;
      } else if (catArray.length == 1) {
        data.url_segment = '/' + catArray[0] + '/' + data.category.sefriendly + dateSeg;
      } else if (catArray.length > 1) {
        data.url_segment = '/' + catArray[0] + '/' + catArray[1] + dateSeg + data.category.sefriendly + '/';
      }

      data.abstract = CKEDITOR.instances.editor.getData();

      // console.log( '>>> data.body', data.body );
      Article.save(
        data,
        function (result) {
          setTimeout(function () {
            growl.info('Article have been created.');
            $location.path('/account/edit-article/' + result.article_id);
          }, 1000);
        },
        formErrors.growlErrors
      ).$promise.then(function () {
        setTimeout(function () {
          $scope.isSaving = false;
        }, 5000);
      });
    };

    $scope.$on('$locationChangeStart', function (event, next, current) {
      if (!$scope.isSaving) {
        return true;
        //var answer = confirm("Are you sure you want to navigate away from this page");
        //if (!answer) {
        //  event.preventDefault();
        //}
      }
    });

    $scope.$watch('file', function (file) {
      if (!file) return;
      $scope.upload(file);
    });

    $scope.createThumb = function (id) {
      return 'https://cloudflarestream.com/' + id + '/thumbnails/thumbnail.jpg';
    };

    $scope.canGetInfo = true;

    $scope.getInfoVideo = function () {
      if ($scope.canGetInfo) {
        Article.getInfoVideo({ mediaId: $scope.data.mediaCloud_id }).$promise.then(function (data) {
          if (data && data.readyToStream && data.duration && data.duration > 0) {
            do {
              var num = Math.floor(Math.random() * Math.floor(data.duration - 0.5));
              if ($scope.durations.indexOf(num) < 0) {
                $scope.data.arrThumbs.push($scope.createThumb(data.uid) + '?time=' + num + 's');
                $scope.durations.push(num);
              }
            } while ($scope.durations.length < 3);
            $scope.data.readyToStream = data.readyToStream;
            $scope.thumbnail = $scope.createThumb(data.uid);
            $scope.data.duration = data.duration;
            growl.success('Completed');
          } else {
            growl.error('Inprogress, check again after 10s');
          }
        });
        $scope.canGetInfo = false;
        window.setTimeout(function () {
          $scope.canGetInfo = true;
        }, 10000);
      }
		};

			$scope.$watch('fileImage', function (file) {
				if (!file) return;
				$scope.uploadImage(file);
			});

		
		      // upload on file select or drop
			$scope.uploadImage = function (file) {
				$scope.uploadingImage = true;
				$scope.thumbnailImage = file;
				Upload.upload({
					url: '/api/articles/upload',
					data: {file: file}
				}).then(function (resp) {
					$scope.uploadingImage = false;
					$scope.thumbnailImage = APP_IMG_URLS.base + resp.data.filename;
					$scope.data.image = resp.data.filename;
				}, function (resp) {
					$scope.uploadingImage = false;
					$scope.thumbnailImage = null;
					console.log('Error status: ' + resp.status);
				}, function (evt) {
					var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					console.log('progress Image: ' + progressPercentage + '% ' + evt.config.data.file.name);
				});
			};

    // upload on file select or drop
    $scope.upload = function (file) {
      $scope.uploading = true;
      $scope.durations = [];
      $scope.progressPercentage = 0;
      // return;
      Upload.upload({
        url: '/api/articles/upload',
        data: { file: file }
      }).then(
        function (resp) {
					$scope.data.video = resp.data.filename;
					$scope.isMultipart = resp.data.multipart;
					$scope.uploading = false;
					$scope.completed = true;
          growl.info('Uploaded successfully!.');
        },
        function (resp) {
          $scope.uploading = false;
          $scope.completed = false;
          $scope.thumbnail = null;
          console.log('Error status: ' + resp.status);
        },
        function (evt) {
          var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
          $scope.progressPercentage = progressPercentage;
          console.log('progress Video: ' + progressPercentage + '% ' + evt.config.data.file.name);
        }
      );
    };

    $scope.loadTags = function (query) {
      return Tag.search({ q: query }).$promise.then(function (tags) {
        if (!tags) return [];
        return tags.map(function (tag) {
          return {
            _id: tag._id,
            text: tag.name,
            name: tag.name,
            sefriendly: slugify(tag.name),
            avatar: tag.avatar || ''
          };
        });
      });
    };

    $scope.changePT1 = function (pt1) {
      var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
        return e._id === pt1;
      });
      if (playerOrTeam.length) {
        $scope.data.equipo_local_name = playerOrTeam[0].name;
      }
    };

    $scope.changePT2 = function (pt2) {
      var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
        return e._id === pt2;
      });
      if (playerOrTeam.length) {
        $scope.data.equipo_visitante_name = playerOrTeam[0].name;
      }
    };

    $scope.loadProfiles = function (query) {
      return adminResource.searchTags({ type: 'profile', name: query }).then(function (profiles) {
        if (!profiles) return [];
        var searchName = query.toLowerCase();
        return profiles.data
          .filter(function (p) {
            var name = p.name.toLowerCase();
            return name.indexOf(searchName) > -1;
          })
          .map(function (p) {
            return {
              _id: p._id,
              name: p.name
            };
          });
      });
    };
  }]);



// WEBPACK FOOTER //
// ./client/src/app/account/add-video/add-video.js